import { UploadController } from './upload.controller';
import template from './upload.html';

export const uploadComponent = {
  name: 'uploadComponent',
  restrict: 'E',
  template,
  controller: UploadController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<'
  }
};
